import React from "react"
import {
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import PropTypes from "prop-types"
import {
  flexBox,
  getMediaFor,
  MEDIA_BREAKPOINT_KEYS,
} from "style/style_snippets"
// import Img from "gatsby-image"
import { GatsbyImage } from "gatsby-plugin-image"

const bigBannerStyle = {
  container: {
    ...getMediaFor("height", "160px", {
      [MEDIA_BREAKPOINT_KEYS.xs]: 200,
      [MEDIA_BREAKPOINT_KEYS.sm]: 550,
      [MEDIA_BREAKPOINT_KEYS.lg]: 600,
      [MEDIA_BREAKPOINT_KEYS.xl]: 650,
    }),
    width: "100%",
    display: "block",
    boxSizing: "border-box",
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
    maxWidth: 1680,
    zIndex: 1,
  },

  fader: {
    background:
      "linear-gradient(90deg, rgba(255,255,255,.8) 0%, rgba(255,255,255,.7) 20%, rgba(255,255,255,0) 100%)",
    position: "absolute !important",
    top: 0,
    left: 0,
    zIndex: -1,
    width: "50%",
    height: "100%",
  },

  bannerImage: {
    position: "absolute !important",
    top: 0,
    left: 0,
    zIndex: -2,
    width: "100%",
    ...getMediaFor("height", "auto", {
      [MEDIA_BREAKPOINT_KEYS.xs]: "auto",
      [MEDIA_BREAKPOINT_KEYS.sm]: "100%",
      [MEDIA_BREAKPOINT_KEYS.md]: "100%",
      [MEDIA_BREAKPOINT_KEYS.lg]: "100%",
      [MEDIA_BREAKPOINT_KEYS.xl]: "100%",
    }),
  },

  tagContainer: {
    ...flexBox.column,
    height: "100%",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    ...getMediaFor("paddingTop", "25px", {
      [MEDIA_BREAKPOINT_KEYS.xs]: "45px",
      [MEDIA_BREAKPOINT_KEYS.sm]: "50px",
      [MEDIA_BREAKPOINT_KEYS.lg]: "60px",
    }),
    position: "relative",
  },

  bannerTitle: {
    color: "black",
    "&:first-letter": { textTransform: "uppercase" },
  },
}

const BigBanner = ({ bannerTitle, imgBanner, disableFading = false }) => {
  const theme = useTheme()

  const mediaMatch = useMediaQuery(
    theme.breakpoints.down(MEDIA_BREAKPOINT_KEYS.xs)
  )

  return (
    <div css={bigBannerStyle.container}>
      <GatsbyImage css={bigBannerStyle.bannerImage} image={imgBanner.childImageSharp.gatsbyImageData} />
      { !disableFading && (
        <div css={bigBannerStyle.fader} />
      )}

      <Container css={bigBannerStyle.tagContainer} maxWidth={"lg"}>
        {!mediaMatch && (
          <Typography css={bigBannerStyle.bannerTitle} variant={"h1"}>
            {bannerTitle}
          </Typography>
        )}
      </Container>
    </div>
  )
}

BigBanner.propTypes = {
  heading: PropTypes.string,
  bannerTitle: PropTypes.string.isRequired,
  imgBanner: PropTypes.object.isRequired,
}

export default BigBanner
